import { api } from '@/apis';
import { isEmpty, log } from '@/utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function usePersonBoundaryPolls({ boundary, query: filter }) {
  const queryKey = ['personBoundaryPolls', boundary, filter];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      const { time, ...match } = filter;

      const featureRequestParams = {
        startTime: time.$gte,
        endTime: time.$lt,
        boundary: boundary,
        ...match,
      };

      log('Read', 'Person Boundary Polls', { boundary, query: filter });

      return api
        .post('boundary-polls/people', {
          json: featureRequestParams,
          signal,
        })
        .json();
    },
    placeholderData: [],
    staleTime: 1000 * 60 * 60 * 8,
    enabled: !!boundary && !isEmpty(filter),
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
